import { IScoreboard } from "../types/INote";
import { shallUseTestMode } from "../hooks/useTestMode";
import type { IPageData } from "../types/IPageData";
import { FetchAugmented } from "./fetch-augmented";

const isTestMode = shallUseTestMode();
const fetch = new FetchAugmented({
  cacheLifetime: 5000,
  origin: isTestMode ? "https://live-api-test.wyborcza.pl" : "https://live-api.wyborcza.pl",
});

export const fetchScoreboardData = async ({
  articleId,
}: {
  articleId: IPageData["articleId"];
}): Promise<IScoreboard> => {
  const response = await fetch.get(`/live/${articleId}/score-board`, { cache: "no-cache" });
  return response.json();
};

// @TODO: Move getData.ts / prepare-request.ts here!
